import merge from "deepmerge"
import { SYSTEM_FONTS } from "app/regions/blocks/shared/fonts"

const commonTypographyStyles = {
  fontFamily: SYSTEM_FONTS,
  fontSize: 18,
  color: "#353535",
  fontWeight: 400,
  letterSpacing: 0,
  lineHeight: 1.5,
  textAlign: "left",
  textTransform: "none"
}

/**
 * Unless otherwise specified by the `theme` function, these values will be used
 * as the defaults for each element.
 */
export const defaultTheme = {
  h1: {
    ...commonTypographyStyles,
    fontSize: 36
  },
  h2: {
    ...commonTypographyStyles,
    fontSize: 32
  },
  h3: {
    ...commonTypographyStyles,
    fontSize: 28
  },
  h4: {
    ...commonTypographyStyles,
    fontSize: 24
  },
  h5: {
    ...commonTypographyStyles,
    fontSize: 20
  },
  h6: {
    ...commonTypographyStyles,
    fontSize: 16
  },
  paragraph: {
    ...commonTypographyStyles
  },
  "ordered-list": {
    ...commonTypographyStyles
  },
  "unordered-list": {
    ...commonTypographyStyles
  },
  blockquote: {
    ...commonTypographyStyles,
    borderLeftWidth: 5,
    borderLeftColor: "#000000"
  },
  link: {
    color: "#0000ff"
  }
}

/**
 * `theme` is a utility function which generates a theme object for starting
 * points. It overrides any default typography settings with the object you
 * pass in. For example, you could pass a custom color to an h1:
 *
 * ```js
 * theme({ h1: { color: "#C0FF33" } })
 * ```
 *
 * This would return a fully-formed theme with values for h1, h2, paragraph,
 * etc., but h1s would have the color "#C0FF33".
 *
 * @param {Object} customSettings
 * @returns {Object} theme object
 */
export function theme(customSettings = {}) {
  return merge(defaultTheme, customSettings)
}

/**
 * `headings` is a utility function for starting points. It applies the same
 * settings to all headings 1-6 so you don't need to type them individually.
 */
export function headings(settings) {
  return theme({
    h1: settings,
    h2: settings,
    h3: settings,
    h4: settings,
    h5: settings,
    h6: settings
  })
}
